/**
 * PDF Processing API endpoint constants.
 */
export const PDF_PROCESSING_ENDPOINTS = {
    INITIATE: '/pdf-processing/initiate-processing',
    GET_STATUS: '/pdf-processing/status',
    GET_RESULT_URL: '/pdf-processing/result-url',
    CONFIRM_DOWNLOAD: '/pdf-processing/confirm-download',
    REPORT_DOWNLOAD_FAILURE: '/pdf-processing/report-download-failure',
    CANCEL_JOB: '/pdf-processing/cancel-job',
};
//# sourceMappingURL=endpoints.js.map